module.exports = __webpack_public_path__ + "static/media/savio3.22cb90e4.jpg";